'use client'

import type { HeadingBlockProps } from '@/blocks/HeadingBlock/HeadingBlock'
import { HeadingBlock } from '@/blocks/HeadingBlock/HeadingBlock'
import { type ExpectedBlockType, type SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { filterByBlockType } from '@/services/storyblok/Storyblok.helpers'
import { BodyWrapper } from './ImageBlock.styles'
import { ImageBlockRenderer, type BaseImageRendererProps } from './ImageBlockRenderer'

export type ImageBlockProps = SbBaseBlockProps<
  BaseImageRendererProps & {
    body?: ExpectedBlockType<HeadingBlockProps>
  }
>

export const ImageBlock = ({ blok, nested }: ImageBlockProps) => {
  const headingBlocks = filterByBlockType(blok.body, HeadingBlock.blockName)

  return (
    <ImageBlockRenderer blok={blok} nested={nested}>
      <BodyWrapper>
        {headingBlocks.map((nestedBlock) => (
          <HeadingBlock key={nestedBlock._uid} blok={nestedBlock} />
        ))}
      </BodyWrapper>
    </ImageBlockRenderer>
  )
}
ImageBlock.blockName = 'image'
